import React from 'react';

/* ─── Konstanter ─── */

export const KARAKTER_OPTIONS = ["-3", "00", "02", "4", "7", "10", "12", "Bestået", "Ikke bestået"];
export const BESTAAET_OPTIONS = ["Bestået", "Ikke bestået"];
export const MOEDESTABILITET_OPTIONS = [
  "Ikke tilfredsstillende",
  "Mindre tilfredsstillende",
  "Tilfredsstillende",
  "Meget tilfredsstillende",
];

const NUMERIC_MAP = { "-3": -3, "00": 0, "02": 2, "4": 4, "7": 7, "10": 10, "12": 12 };

/* ─── Beregn gennemsnit ─── */

export function beregnGennemsnit(karakterer) {
  const nums = (karakterer || [])
    .map(k => {
      const val = typeof k === 'string' ? k : k.karakter || k.aarskarakter || k.eksamenskarakter;
      return NUMERIC_MAP[val];
    })
    .filter(n => n !== undefined && n !== null);
  if (nums.length === 0) return null;
  return (nums.reduce((a, b) => a + b, 0) / nums.length).toFixed(1);
}

/* ─── Karakter-badge med farve ─── */

export function KarakterBadge({ karakter }) {
  if (!karakter) return <span className="text-[13px] text-muted-foreground italic">—</span>;
  const lower = karakter.toLowerCase();
  const cls =
    ["-3", "00", "02"].includes(karakter) ? "text-red-500 bg-red-500/10 border-red-500/20" :
    ["4", "7"].includes(karakter) ? "text-amber-500 bg-amber-500/10 border-amber-500/20" :
    ["10", "12"].includes(karakter) ? "text-green-600 dark:text-green-400 bg-green-500/10 border-green-500/20" :
    lower === "bestået" ? "text-green-600 dark:text-green-400 bg-green-500/10 border-green-500/20" :
    lower === "ikke bestået" ? "text-red-500 bg-red-500/10 border-red-500/20" :
    "text-foreground bg-secondary border-border";
  return <span className={`text-sm font-bold px-2 py-0.5 rounded-lg border ${cls}`}>{karakter}</span>;
}

/* ─── Karakter select dropdown ─── */

export function KarakterSelect({ value, onChange, className = "" }) {
  return (
    <select
      value={value || ""}
      onChange={e => onChange(e.target.value)}
      className={`bg-secondary border border-border rounded-md px-2 py-1.5 text-sm text-foreground focus:outline-none focus:ring-1 focus:ring-primary ${className}`}
    >
      <option value="">—</option>
      {KARAKTER_OPTIONS.map(o => <option key={o} value={o}>{o}</option>)}
    </select>
  );
}

/* ─── Bestået / Ikke bestået toggle ─── */

export function BestaetToggle({ value, onChange }) {
  return (
    <div className="flex gap-1">
      {BESTAAET_OPTIONS.map(opt => (
        <button
          key={opt}
          type="button"
          onClick={() => onChange(value === opt ? "" : opt)}
          className={`text-[13px] px-2.5 py-1.5 rounded-md border font-medium transition-colors ${
            value === opt
              ? opt === "Bestået"
                ? "bg-green-500/15 text-green-600 dark:text-green-400 border-green-500/30"
                : "bg-red-500/15 text-red-500 border-red-500/30"
              : "bg-secondary text-muted-foreground border-border hover:bg-secondary/80"
          }`}
        >
          {opt === "Bestået" ? "Bestået" : "Ikke best."}
        </button>
      ))}
    </div>
  );
}

/* ─── Antal fejl input ─── */

export function AntalFejlInput({ value, onChange, className = "" }) {
  return (
    <input
      type="number"
      min="0"
      value={value ?? ""}
      onChange={e => onChange(e.target.value === "" ? null : parseInt(e.target.value, 10))}
      placeholder="Fejl"
      className={`bg-secondary border border-border rounded-md px-2 py-1.5 text-sm text-foreground w-20 focus:outline-none focus:ring-1 focus:ring-primary ${className}`}
    />
  );
}

/* ─── Dato felt ─── */

export function DatoField({ value, onChange, className = "" }) {
  return (
    <input
      type="date"
      value={value || ""}
      onChange={e => onChange(e.target.value)}
      className={`bg-secondary border border-border rounded-md px-2 py-1.5 text-sm text-foreground focus:outline-none focus:ring-1 focus:ring-primary ${className}`}
    />
  );
}

/* ─── Underviser select ─── */

export function UnderviserSelect({ value, onChange, undervisere = [], className = "" }) {
  return (
    <select
      value={value || ""}
      onChange={e => onChange(e.target.value)}
      className={`bg-secondary border border-border rounded-md px-2 py-1.5 text-sm text-foreground focus:outline-none focus:ring-1 focus:ring-primary ${className}`}
    >
      <option value="">Vælg underviser</option>
      {undervisere.map(u => <option key={u} value={u}>{u}</option>)}
    </select>
  );
}

/* ─── Mødestabilitet select ─── */

export function MoedestabilitetSelect({ value, onChange, className = "" }) {
  return (
    <select
      value={value || ""}
      onChange={e => onChange(e.target.value)}
      className={`bg-secondary border border-border rounded-md px-2 py-1.5 text-sm text-foreground focus:outline-none focus:ring-1 focus:ring-primary ${className}`}
    >
      <option value="">—</option>
      {MOEDESTABILITET_OPTIONS.map(o => <option key={o} value={o}>{o}</option>)}
    </select>
  );
}
